import styled from "styled-components";

const Container = styled.a`
width: min-content;`;

const Image = styled.img`
width:50px;`;

const SocialButton  = props =>
{
    return <Container target="_blank" href={props.link}>
        <Image src={props.image}/> 
    </Container>
}

export default SocialButton;